import SelectedListItems from "./selected-list-items";

export default SelectedListItems;
